var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"dragDiv",class:[_vm.prefixCls],style:(_vm.setWidth)},[(_vm.imgUrl)?_c('img',{ref:"dragImg",style:(_vm.setImgWidth),attrs:{"src":_vm.imgUrl},on:{"wheel":_vm.wheel,"mousedown":_vm.move}}):_vm._e()])])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/dragImg/dragImg.vue